import { render, staticRenderFns } from "./OpenDialogsProButton.vue?vue&type=template&id=5e5cfe10&"
import script from "./OpenDialogsProButton.vue?vue&type=script&lang=js&"
export * from "./OpenDialogsProButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports